module.exports = __webpack_public_path__ + "static/media/icon-raio.132314c4.svg";